export function replaceHyphensWithSpaces(input: string): string {
  return input.replace(/-/g, ' ');
}
